import { SvgIcon } from '@mui/material';

export function InfoCircle() {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C8.96271 1 6.21134 2.23231 4.22183 4.22183C2.23231 6.21134 1 8.96271 1 12C1 15.0373 2.23231 17.7887 4.22183 19.7782C6.21134 21.7677 8.96271 23 12 23C15.0373 23 17.7887 21.7677 19.7782 19.7782C21.7677 17.7887 23 15.0373 23 12C23 8.96271 21.7677 6.21134 19.7782 4.22183C17.7887 2.23231 15.0373 1 12 1ZM12 6C11.3096 6 10.75 6.55964 10.75 7.25C10.75 7.94036 11.3096 8.5 12 8.5C12.6904 8.5 13.25 7.94036 13.25 7.25C13.25 6.55964 12.6904 6 12 6ZM13 11.1192L13 11.11C13 10.5577 12.5523 10.11 12 10.11H10C9.44772 10.11 9 10.5577 9 11.11C9 11.6623 9.44772 12.11 10 12.11H11V17.0996C11 17.6598 11.4477 18.114 12 18.114C12.5523 18.114 13 17.6598 13 17.0996V11.1285L13 11.1192Z"
        fill="#5B68F6"
      />
    </SvgIcon>
  );
}
